// Google Consent Mode v2 helper
const STORAGE_KEY = "zantravela_consent_v2";

export function readStoredConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveConsent(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {}
}

export function clearConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}

function gtagSafe(...args) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

export function updateConsent(prefs) {
  const state = {
    ad_storage: prefs.ads ? "granted" : "denied",
    ad_user_data: prefs.ads ? "granted" : "denied",
    ad_personalization: prefs.ads ? "granted" : "denied",
    analytics_storage: prefs.analytics ? "granted" : "denied",
    functionality_storage: prefs.functional ? "granted" : "denied",
    personalization_storage: prefs.functional ? "granted" : "denied",
    security_storage: "granted",
  };
  saveConsent(state);

  // gtag consent update
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: state.ad_storage,
      ad_user_data: state.ad_user_data,
      ad_personalization: state.ad_personalization,
      analytics_storage: state.analytics_storage,
      functionality_storage: state.functionality_storage,
      personalization_storage: state.personalization_storage,
      security_storage: state.security_storage,
    });
  } else {
    gtagSafe("consent", "update", state);
  }

  // Push consent event to dataLayer
  gtagSafe({ event: "cookie_consent_update" });

  return state;
}

export function acceptAll() {
  return updateConsent({ ads: true, analytics: true, functional: true });
}
export function rejectAll() {
  return updateConsent({ ads: false, analytics: false, functional: false });
}
